/**
 * Cookie consent
 *
 * @copyright 2024 Linguistica 360
 */

import { run as runConsent } from 'vanilla-cookieconsent';

import { Script, injector } from '../shared/injector.js';
import { resolveRoot } from '../shared/utils.js';

injector.injectClass(class extends Script {
    onLoad() {
        const contactUrl = resolveRoot('/contact-us');

        runConsent({
            onConsent: ({ cookie }) => {
                if (!window.updateConsent) {
                    console.log('Debug Mode Consent: ', cookie);
                } else {
                    const ads = cookie.categories.includes('ads');
                    const analytics = cookie.categories.includes('analytics');
                    window.updateConsent(ads, analytics);
                }
            },

            categories: {
                necessary: {
                    enabled: true,  // this category is enabled by default
                    readOnly: true,  // this category cannot be disabled
                },

                analytics: {
                    enabled: true,
                    autoClear: {
                        cookies: [{ name: /^_ga/ }, { name: '_gid' }],
                    },
                },

                ads: {},
            },

            language: {
                default: 'en',
                translations: {
                    en: {
                        consentModal: {
                            title: 'We use cookies',
                            // eslint-disable-next-line max-len
                            description: 'We use cookies to give you the best online experience. Please let us know if you accept the use of these cookies.',
                            acceptAllBtn: 'Accept all',
                            acceptNecessaryBtn: 'Reject all',
                            showPreferencesBtn: 'Manage Individual preferences',
                        },

                        preferencesModal: {
                            title: 'Manage cookie preferences',
                            acceptAllBtn: 'Accept all',
                            acceptNecessaryBtn: 'Reject all',
                            savePreferencesBtn: 'Accept current selection',
                            closeIconLabel: 'Close modal',
                            sections: [
                                {
                                    title: 'Strictly Necessary cookies',
                                    // eslint-disable-next-line max-len
                                    description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                                    linkedCategory: 'necessary',
                                },
                                {
                                    title: 'Performance and Analytics',
                                    // eslint-disable-next-line max-len
                                    description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                                    linkedCategory: 'analytics',
                                },
                                {
                                    title: 'Targeting and Advertising',
                                    // eslint-disable-next-line max-len
                                    description: 'These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.',
                                    linkedCategory: 'ads',
                                },
                                {
                                    title: 'More information',
                                    // eslint-disable-next-line max-len
                                    description: `For any queries in relation to my policy on cookies and your choices, please <a href="${contactUrl}">contact us</a>`,
                                },
                            ],
                        },
                    },
                },
            },
        });
    }
});
